import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// Función para obtener un color basado en la puntuación
const getScoreColor = (score) => {
  if (score <= 3) return 'rgba(239, 68, 68, 0.9)'; // Rojo
  if (score <= 6) return 'rgba(250, 204, 21, 0.9)'; // Amarillo
  return 'rgba(74, 222, 128, 0.9)'; // Verde
};

const LifeWheelChart = ({ ratings, areasData }) => {
  const data = {
    labels: areasData.map(area => area.title.replace(/^\d+\.\s*/, '')), // "1. Tu Relación Amorosa" -> "Tu Relación Amorosa"
    datasets: [
      {
        label: 'Tu Balance Actual',
        data: areasData.map(area => ratings[area.id] || 0),
        backgroundColor: 'rgba(252, 211, 77, 0.2)', // Relleno amarillo translúcido
        borderColor: 'rgba(252, 211, 77, 1)', // Borde amarillo sólido
        borderWidth: 2,
        pointBackgroundColor: areasData.map(area => getScoreColor(ratings[area.id] || 0)),
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: (context) => getScoreColor(context.raw),
        pointRadius: 5,
        pointHoverRadius: 8,
      },
    ],
  };

  const options = {
    scales: {
      r: {
        angleLines: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.2)',
        },
        pointLabels: {
          color: '#e5e7eb', // Gris claro para las etiquetas
          font: {
            size: 11,
          },
        },
        ticks: {
          color: '#9ca3af', // Gris más oscuro para los números (0, 2, 4...)
          backdropColor: 'rgba(0, 0, 0, 0.7)',
          stepSize: 2,
        },
        min: 0,
        max: 10,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.raw}`,
        },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-gray-800/50 p-2 sm:p-4 rounded-xl relative" style={{ height: '350px', sm: { height: '450px' } }}>
      <Radar data={data} options={options} />
    </div>
  );
};

export default LifeWheelChart;